/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsHealthSummary } from './vcdsHealthSummary';


export interface VcdsApplicationHealth { 
    general?: Array<VcdsHealthSummary>;
    protection?: Array<VcdsHealthSummary>;
    recovery?: Array<VcdsHealthSummary>;
    storage?: Array<VcdsHealthSummary>;
}

